import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../endpoints";
import { getResource } from "../https";
import { Brand } from "../types";
import { querykeys } from "../querykeys";

interface BrandResponse {
  data: Brand[];
}

export const getBrands = async (): Promise<BrandResponse> => {
  return await getResource({
    pathUrl: `${endpoints.brand}`,
  });
};

export const useGetAllBrands = () => {
  const query = useQuery({
    queryKey: [querykeys.GET_BRANDS],
    queryFn: () => getBrands(),
  });
  return query;
};
